import React from 'react'
import GiftCardThankYouPage from '../../components/User/GiftCardThankYou';

const GiftCardThankYouComp = () => {
  return (
    <GiftCardThankYouPage />
  )
}

export default GiftCardThankYouComp;